<template>
  <v-row no-gutters class="document-footer">
    <v-col cols="12">
      <slot />
    </v-col>
    <template v-if="props.intakeStatus === 'Qualify Patient'">
      <v-col cols="3">
        <v-btn class="go-back" @click="onBack">Go Back</v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-btn class="float-right" @click="onclickQualifySubmit">Looks Good</v-btn>
      </v-col>
    </template>
  </v-row>
</template>

<script setup>
const emit = defineEmits(["submit-step", "back-step"]);
const props = defineProps({
  intakeStatus: { type: String, required: true },
});

const onclickQualifySubmit = () => {
  emit("submit-step");
};

const onBack = () => {
  emit("back-step");
};
</script>

<!-- TODO: split css files -->
<style lang="scss" scoped>
@import "@/styles/pages/_patient-intake-review.scss";
</style>
